// extracted by mini-css-extract-plugin
export default {"container":"Y5PHy","iconContainer":"c2e7e","icon":"ybVCD","logo":"YWHjs","label":"pOP1H"};